import React from "react";
import {NodeType} from "../../../../../model/ModelData";
import {ToggleRow} from "../components/EditMenuSection";

export const useLLMNodes = [
    NodeType.QA, NodeType.CHOICE, NodeType.INPUT, NodeType.TEACHING,
    NodeType.TEXT, NodeType.QUERY, NodeType.RECOMMENDATION, NodeType.START_FORM,
];

export const LLMSettings = ({node, onUpdate, onChangeData}) => {
    if (!useLLMNodes.includes(node?.type)) return null;

    return (
        <ToggleRow
            label="Use LLM"
            checked={node?.data?.use_llm}
            onChange={(event) => onChangeData("use_llm", event.target.checked)}
            onBlur={() => onUpdate(node)}
        />
    );
};
